<template>
    <div class="flex items-center mx-auto gap-12">
        <button 
            class="p-2 w-[220px] hover:bg-indigo-300 hover:text-white transition duration-300 rounded-xl"
            :class="currentAnalyticsType === 1  && 'bg-indigo-400 text-white'" 
            @click="changeAnalyticsType(1)">
             Дні народження клієнтів
        </button>
        <button 
            class="p-2 w-[220px] hover:bg-indigo-300 hover:text-white transition duration-300 rounded-xl"
            :class="currentAnalyticsType === 2  && 'bg-indigo-400 text-white'" 
            @click="changeAnalyticsType(2)">
             Дні народження тренерів
        </button>
        <button 
            class="p-2 w-[220px] hover:bg-indigo-300 hover:text-white transition duration-300 rounded-xl"
            :class="currentAnalyticsType === 3  && 'bg-indigo-400 text-white'" 
            @click="changeAnalyticsType(3)">
             Неактивні клієнти
        </button>

    </div>

</template>


<script>
export default {
    name: "AnalyticsTypeSwitcher",
    emits: ["update:modelValue"],
    props: {
        currentAnalyticsType: Number,
    },
    data: function () {
        return {

        }
    },
    methods: {
        changeAnalyticsType(type) {
            this.$emit("update:modelValue", type);
        }
    }
}
</script>